(() => {
  function prepare(scope = document) {
    const sections = [...scope.querySelectorAll('[data-mc-photo-reviews]')];
    if (scope.matches?.('[data-mc-photo-reviews]')) sections.unshift(scope);
    sections.forEach(section => {
      if (section.dataset.reviewsReady) return;
      section.dataset.reviewsReady = 'true';
      section.querySelectorAll('[data-mc-review-toggle]').forEach(button => {
        const text = section.querySelector(`[id="${button.getAttribute('aria-controls')}"]`);
        if (!text) return;
        text.hidden = true;
        button.hidden = false;
        button.setAttribute('aria-expanded', 'false');
        button.textContent = section.dataset.readMore;
        button.addEventListener('click', () => {
          text.hidden = !text.hidden;
          button.setAttribute('aria-expanded', String(!text.hidden));
          button.textContent = text.hidden ? section.dataset.readMore : section.dataset.readLess;
        });
      });
      if(section.hasAttribute('data-mc-review-carousel')){
        const grid=section.querySelector('.mc-photo-reviews__grid'),cards=[...section.querySelectorAll('[data-mc-review-card]')],dots=[...section.querySelectorAll('[data-mc-review-dot]')],prev=section.querySelector('[data-mc-review-prev]'),next=section.querySelector('[data-mc-review-next]');
        const step=()=>cards[1]?cards[1].offsetLeft-cards[0].offsetLeft:cards[0]?.offsetWidth||1;
        const update=()=>{const last=Math.max(0,Math.ceil((grid.scrollWidth-grid.clientWidth-2)/step())),index=grid.scrollLeft+grid.clientWidth>=grid.scrollWidth-2?last:Math.round(grid.scrollLeft/step());dots.forEach((dot,i)=>{dot.hidden=i>last;dot.setAttribute('aria-current',String(i===index));});prev.disabled=grid.scrollLeft<2;next.disabled=grid.scrollLeft+grid.clientWidth>=grid.scrollWidth-2;};
        const move=x=>grid.scrollTo({left:x,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
        prev.addEventListener('click',()=>move(grid.scrollLeft-step()));next.addEventListener('click',()=>move(grid.scrollLeft+step()));dots.forEach((dot,i)=>dot.addEventListener('click',()=>move(i*step())));
        grid.addEventListener('scroll',update,{passive:true});window.addEventListener('resize',update);update();
        return;
      }
      const extraCards = [...section.querySelectorAll('[data-mc-review-card]')].slice(4);
      const button = section.querySelector('[data-mc-reviews-toggle]');
      if (!button || !extraCards.length) return;
      const setExpanded = expanded => {
        extraCards.forEach(card => { card.hidden = !expanded; });
        button.setAttribute('aria-expanded', String(expanded));
        button.textContent = expanded ? section.dataset.showLess : section.dataset.showMore;
      };
      setExpanded(false);
      button.hidden = false;
      button.addEventListener('click', () => setExpanded(button.getAttribute('aria-expanded') !== 'true'));
      section.addEventListener('shopify:block:select', event => {
        if (extraCards.some(card => card.contains(event.target))) setExpanded(true);
      });
    });
  }
  document.addEventListener('shopify:section:load', event => prepare(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => prepare());
  else prepare();
})();
